import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TypeScript interface for research state
interface ResearchState {
  researchMode: 'none' | 'web' | 'deep';
}

const initialState: ResearchState = {
  researchMode: 'none',
};

const researchSlice = createSlice({
  name: 'research',
  initialState,
  reducers: {
    setResearchMode: (state, action: PayloadAction<'none' | 'web' | 'deep'>) => {
      state.researchMode = action.payload;
    },
    clearResearchMode: (state) => {
      state.researchMode = 'none';
    },
    toggleWebResearch: (state) => {
      // Toggle web research mode
      state.researchMode = state.researchMode === 'web' ? 'none' : 'web';
    },
    toggleDeepResearch: (state) => {
      // Toggle deep research mode
      state.researchMode = state.researchMode === 'deep' ? 'none' : 'deep';
    },
  },
});

export const { setResearchMode, clearResearchMode, toggleWebResearch, toggleDeepResearch } = researchSlice.actions;

// Export types for use in components
export type { ResearchState };

export default researchSlice.reducer;
